import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import { BlocksRenderer } from "../../../components/BlockRenderer";
import { fetchData } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
const SMSAchivements = () => {
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.achivements, setData);
    fetchData(getAPIPath()?.event_attended, setTableData);
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Achivements – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Achivements"
          pageName="Achivements"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 style={{ marginBottom: "20px" }} title={data?.data?.attributes?.Page_Heading}>
                      {data?.data?.attributes?.Page_Heading}
                    </h3>
                    {
                      <BlocksRenderer
                        content={data?.data?.attributes?.Body || []}
                      />
                    }
                    <h4 style={{ marginTop: "30px" }} title="EVENTS ATTENDED">EVENTS ATTENDED</h4>
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">NAMES</th>
                          <th scope="col">EVENT</th>
                          <th scope="col">YEAR</th>
                          <th scope="col">AWARD</th>
                          <th scope="col">Organizers</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData?.data?.map((obj, index) => (
                          <tr>
                            <td>{obj?.attributes?.NAMES}</td>
                            <td>{obj?.attributes?.EVENT}</td>
                            <td>{obj?.attributes?.YEAR}</td>
                            <td>{obj?.attributes?.AWARD}</td>
                            <td>{obj?.attributes?.Organizers}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SMSAchivements;
